export class Reservation {
    static getAsString(data) {
        const bookingClone = {};
        for (const [key, value] of Object.entries(data)) {
            bookingClone[key] = value.map((r) => ({
                id: r.id,
                startDate: r.startDate,
                endDate: r.endDate,
                numberOfUnits: r.numberOfUnits,
                inventory: r.inventory,
                propertyTicker: r.propertyTicker,
                selectedServices: r.services || {},
            }));
        }
        return JSON.stringify(bookingClone);
    }
}
